export default "__VITE_ASSET__DfjvLjH1__"